import { render } from "./LView.vue?vue&type=template&id=3b0a8912"
import script from "./LView.vue?vue&type=script&lang=js"
export * from "./LView.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__